//
// Options to be provided to Valstream constructor.
function ValstreamOptions(){

    this.biddingManager  = null;
    this.googleAnalytics = null;
    this.videoJsLibrary  = null;
    this.googleLibrary   = null;

    //
    // biddingManager
    this.get_biddingManager = function(){

        return this.biddingManager;
    };
    this.set_biddingManager = function(value){

        this.biddingManager = value;
    };

    //
    // googleAnalytics
    this.get_googleAnalytics = function(){

        return this.googleAnalytics;
    };
    this.set_googleAnalytics = function(value){

        this.googleAnalytics = value;
    };

    //
    // videoJsLibrary
    this.get_videoJsLibrary = function(){

        return this.videoJsLibrary;
    };
    this.set_videoJsLibrary = function(value){

        this.videoJsLibrary = value;
    };

    //
    // googleLibrary
    this.get_googleLibrary = function(){

        return this.googleLibrary;
    };
    this.set_googleLibrary = function(value){

        this.googleLibrary = value;
    };
}

window.ValstreamOptions = ValstreamOptions;